import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

// Non-premium users get ~5 minutes of normal access per day. After that the
// upgrade paywall (CreditModal, via the mel:credits-blocked event) appears and
// keeps re-appearing (~every 20s) until they upgrade. Time is counted only
// while the tab is visible and is scoped per calendar day in localStorage.
const FREE_DAILY_SECONDS = 5 * 60;
const TICK_MS = 10000;
const RENAG_MS = 20000;

export default function FreeTimeGate() {
  const { user, premium } = useAuth();

  useEffect(() => {
    if (!user || premium) return;
    const today = new Date().toISOString().slice(0, 10);
    const key = `melletic_free_secs_${today}`;
    let secs = parseInt(localStorage.getItem(key) || "0", 10) || 0;
    let lastNag = 0;

    const fire = () => {
      window.dispatchEvent(new CustomEvent("mel:credits-blocked", { detail: { code: "daily_cap", plan: "free" } }));
      lastNag = Date.now();
    };

    if (secs >= FREE_DAILY_SECONDS) fire();

    const id = setInterval(() => {
      if (document.visibilityState !== "visible") return;
      secs += TICK_MS / 1000;
      localStorage.setItem(key, String(secs));
      if (secs >= FREE_DAILY_SECONDS && Date.now() - lastNag >= RENAG_MS) fire();
    }, TICK_MS);

    return () => clearInterval(id);
  }, [user, premium]);

  return null;
}
